"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersect = void 0;
const intersect = (firstList, secondList) => {
    return firstList.filter((value) => secondList.includes(value));
};
exports.intersect = intersect;
//# sourceMappingURL=intersect.js.map